export default __webpack_public_path__ + "scenes30e51b9.png";